const allFocusableElemets = `
  a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]),
  input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled]),
  div[role="button"]:not([disabled])
`

const getAllFocusableElements = (element: HTMLElement): NodeListOf<HTMLElement> => element.querySelectorAll(allFocusableElemets)


export default getAllFocusableElements
